import React, { Component } from 'react';
import SpinnerPage from './SpinnerPage';


export default class PatientReportPage extends Component {
    constructor() {
        super();

        this.state = {
            showSpinner: false
        };
    }

    componentDidMount() {
        //window.location.replace("https://dev.watermarkmedical.com/SleepMed.Service.Main/hst/ShowReport");

        // show spinner, while we retrieve info
        this.setState({ showSpinner: true });

        var getPatientReport = () => {
            return fetch(this.props.baseAPIURL + "/SleepMed.Service.Main/hst/ShowReport", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: this.props.securityInfo
            })
            .then((response) => response.blob())
            .then((blob) => {
                // hide spinner
                this.setState({ showSpinner: false });

                // IE 11 and Edge legacy version cannot show inline PDFs
                // so we have to check if IE-specific function exists and
                // use it instead
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // we have an IE or legacy Edge browser, use custom MS API
                    window.navigator.msSaveOrOpenBlob(blob, 'report.pdf');
                } else {
                    // we're dealing with a more modern browser
                    // open PDF by creating file link from blob object
                    let fileURL = URL.createObjectURL(blob);
                    window.location.replace(fileURL);
                }

                // // open PDF by creating file link from blob object
                // let fileURL = URL.createObjectURL(blob);
                // window.location.replace(fileURL);
            })
            .catch((error) => {
                // TODO: what do we do on error when calling API?
                // for now, log to console
                console.log(error);
                alert("error");
            });
        };

        getPatientReport();
    }

    render() {
        return(
            <div>
                <p>Please wait while your report loads ...</p>
                <SpinnerPage show={this.state.showSpinner} />
            </div>
        );
    }
}